/* "Sunday Service is on — 9 am English · Check in", at the top of Home.
 *
 * Present only while a service is on and this person has not checked in;
 * the server decides both. Refetched whenever the window comes back into
 * focus, so it appears as somebody walks in and goes once they are in.
 */
import { useState } from 'react'
import { MapPin } from 'lucide-react'
import { useAttendanceToday } from '@/api/queries'
import { CheckInDialog } from './CheckIn'
import { clock } from './parts'

export function ServiceBanner({ churchId }: { churchId: string | null }) {
  const today = useAttendanceToday(churchId)
  const [open, setOpen] = useState<string | null>(null)
  const t = today.data
  const banner = t?.banner

  if (!churchId || !t) return null

  const service = banner
    ? t.services.find((s) => s.occurrence_id === banner.occurrence_id)
    : null
  const slot = service?.slots.find((s) => s.id === banner?.slot_id)

  return (
    <>
      {banner ? (
        <button
          type="button"
          onClick={() => setOpen(banner.occurrence_id)}
          className="flex w-full items-center gap-s3 rounded-lg bg-brand px-s4 py-s3 text-left text-ink-on-brand shadow-1 transition-colors hover:bg-brand-hover"
        >
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-pill bg-white/20">
            <MapPin className="h-5 w-5" aria-hidden />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-base font-bold">{banner.name} is on</span>
            {banner.slot_label ? (
              <span className="block truncate text-sm opacity-90">
                {slot ? `${clock(slot.starts_at)} ` : ''}
                {banner.slot_label}
              </span>
            ) : null}
          </span>
          <span className="shrink-0 rounded-pill bg-white px-s3 py-1.5 text-sm font-bold text-brand">
            Check in
          </span>
        </button>
      ) : null}

      {open ? (
        <CheckInDialog
          churchId={churchId}
          occurrenceId={open}
          today={t}
          onClose={() => setOpen(null)}
        />
      ) : null}
    </>
  )
}
